import { useState } from "react";
import { Instagram, Menu, X } from "lucide-react";
import { Logo } from "./Logo";

const LINKS = [
  ["Serviços", "servicos"],
  ["Processo", "processo"],
  ["Estúdio", "estudio"],
  ["Contato", "contato"],
];

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export default function Nav({ onOrder }) {
  const [open, setOpen] = useState(false);

  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header data-testid="site-header" className="fixed inset-x-0 top-0 z-40 border-b border-line/70 bg-paper/80 backdrop-blur-md">
      <div className="mx-auto flex max-w-[1400px] items-center justify-between px-6 py-4 sm:px-12 lg:px-20">
        <a href="/" data-testid="nav-logo-link" aria-label="Essenza — início">
          <Logo />
        </a>
        <nav className="hidden items-center gap-8 md:flex">
          {LINKS.map(([label, id]) => (
            <button
              key={id}
              data-testid={`nav-link-${id}`}
              onClick={() => go(id)}
              className="font-mono text-[11px] uppercase tracking-[0.2em] text-ink-2 transition-colors hover:text-accent"
            >
              {label}
            </button>
          ))}
        </nav>
        <div className="hidden items-center gap-3 md:flex">
          <a
            href="https://www.instagram.com/essenzaabr"
            target="_blank"
            rel="noreferrer"
            data-testid="nav-instagram-link"
            aria-label="Instagram @essenzaabr"
            className="flex h-10 w-10 items-center justify-center rounded-full border border-line text-ink transition-colors hover:border-ink"
          >
            <Instagram className="h-4 w-4" />
          </a>
          <button
            data-testid="nav-order-cta-button"
            onClick={onOrder}
            className="btn-lift rounded-full bg-ink px-6 py-2.5 font-mono text-[11px] uppercase tracking-[0.2em] text-paper hover:bg-accent"
          >
            Fazer pedido
          </button>
        </div>
        <button
          className="flex h-10 w-10 items-center justify-center rounded-full border border-line md:hidden"
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen(!open)}
          aria-label="Abrir menu"
        >
          {open ? <X className="h-4 w-4" /> : <Menu className="h-4 w-4" />}
        </button>
      </div>
      {open && (
        <div className="border-t border-line bg-paper px-6 py-6 md:hidden" data-testid="nav-mobile-menu">
          <div className="flex flex-col gap-4">
            {LINKS.map(([label, id]) => (
              <button
                key={id}
                onClick={() => go(id)}
                className="text-left font-display text-2xl font-bold tracking-tight"
              >
                {label}
              </button>
            ))}
            <div className="mt-2 flex items-center gap-3">
              <button
                data-testid="nav-mobile-order-button"
                onClick={() => {
                  setOpen(false);
                  onOrder();
                }}
                className="btn-lift flex-1 rounded-full bg-ink px-6 py-3 font-mono text-[11px] uppercase tracking-[0.2em] text-paper"
              >
                Fazer pedido
              </button>
              <a
                href="https://www.instagram.com/essenzaabr"
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram @essenzaabr"
                className="flex h-11 w-11 items-center justify-center rounded-full border border-line"
              >
                <Instagram className="h-4 w-4" />
              </a>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
